module.exports = __webpack_public_path__ + "assets/ic_badge_05.10ac66ac.svg";